import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTemples } from "../redux/templeSlice";
import { getTempleImageUrl } from "../utils/imageHelper";

/* ── Styled placeholder for temples without real photos ── */
const ImagePlaceholder = ({ name, height = "200px" }) => (
  <div
    style={{
      width: "100%",
      height,
      background: "linear-gradient(135deg, #f5f0e8 0%, #e8ddd0 100%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#8b7355",
      fontSize: "14px",
      fontWeight: "500",
      border: '0px solid red'
    }}
  >
    <span style={{ fontSize: "32px", marginBottom: "6px" }}>🛕</span>
    <span>{name || "Image Coming Soon"}</span>
  </div>
);

function TempleList() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { temples } =
    useSelector(state => state.temples);

  const [searchTerm, setSearchTerm] =
    useState("");

  const [popupContent, setPopupContent] =
    useState("");

  const [popupTitle, setPopupTitle] =
    useState("");

  useEffect(() => {
    dispatch(fetchTemples());
  }, [dispatch]);

  /* ---------- SEARCH FILTER ---------- */

  const filteredTemples = temples.filter(t => {
    const term = searchTerm.toLowerCase();
    return (
      (t.name && t.name.toLowerCase().includes(term)) ||
      (t.location && t.location.toLowerCase().includes(term)) ||
      (t.category && t.category.toLowerCase().includes(term)) ||
      (t.deity && t.deity.toLowerCase().includes(term))
    );
  });

  /* ---------- POPUP CONTENT ---------- */

  const openPopup = (temple, type) => {

    switch (type) {

      case "history":
        setPopupTitle("📜 Temple History");
        setPopupContent(temple.history);
        break;

      case "timings":
        setPopupTitle("⏰ Temple Timings");
        setPopupContent(temple.timings);
        break;

      case "abhishek":
        setPopupTitle("🌸 Abhishek Details");
        setPopupContent(temple.abhishekDetails);
        break;

      case "pooja":
        setPopupTitle("🪔 Pooja Details");
        setPopupContent(temple.poojaDetails);
        break;

      case "bhandara":
        setPopupTitle("🎉 Bhandara / Yatra");
        setPopupContent(temple.bhandaraYatraDetails);
        break;

      case "bhojan":
        setPopupTitle("🍛 Bhojan Prasadi");
        setPopupContent(temple.bhojanPrasadi);
        break;

      case "trustees":

        setPopupTitle("👥 Trustees");

        setPopupContent(
          temple.trustees.map(t =>
            `Name: ${t.name}
Position: ${t.position}
Contact: ${t.contact}

`
          ).join("")
        );

        break;

      default:
        setPopupContent("");
    }

  };

  return (

    <div className="container mt-4" >

      <h2 className="fw-bold text-center mb-4">
        <i className="bi bi-search me-1"></i> Search Temples
      </h2>

      {/* SEARCH BAR */}

      <div className="row justify-content-center mb-4" >

        <div className="col-md-6">

          <input
            type="text"
            className="form-control shadow"
            placeholder="Search by temple name, location or category..."
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(e.target.value)
            }
          />

        </div>

      </div>

      {/* TEMPLE CARDS */}

      <div className="row" >

        {filteredTemples.length === 0 ? (

          <h5 className="text-center text-danger">
            No temples found
          </h5>

        ) : (

          filteredTemples.map(t => {
            const imgUrl = getTempleImageUrl(t.image);
            return (
              <div
                className="col-md-3 col-sm-6 mb-4"
                key={t._id} style={{ border: '0px solid red' }}

              >

                <div className="card shadow h-100">

                  {/* IMAGE CLICK → OPEN GALLERY */}

                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={t.name}
                      className="card-img-top"
                      style={{
                        height: "200px",
                        objectFit: "cover",
                        cursor: "pointer"
                      }}
                      onClick={() =>
                        navigate(`/gallery/${t._id}`)
                      }
                    />
                  ) : (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/gallery/${t._id}`)}
                    >
                      <ImagePlaceholder name={t.name} height="200px" />
                    </div>
                  )}

                  <div className="card-body text-center" style={{ border: '0px solid red' }}>
                    <div style={{ border: '0px solid blue', height: '200px' }}>
                      <h5 className="fw-bold">
                        {t.name}
                      </h5>

                      <p className="text-muted mb-1">
                        {t.location}
                      </p>

                      <span className="badge bg-secondary mb-2">
                        {t.category}
                      </span>
                    </div>



                    {/* VIEW FULL DETAILS */}

                    <Link
                      to={`/temple/${t._id}`}
                      className="btn btn-primary btn-sm w-100 mt-2"
                    >
                      View Details
                    </Link>

                    {/* QUICK VIEW */}

                    <div className="dropdown mt-2">

                      <button
                        className="btn btn-success btn-sm dropdown-toggle w-100"
                        data-bs-toggle="dropdown"
                      >
                        Quick View Details
                      </button>

                      <ul className="dropdown-menu w-100">

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "history")
                            }
                          >
                            History
                          </button>
                        </li>

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "timings")
                            }
                          >
                            Timings
                          </button>
                        </li>

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "abhishek")
                            }
                          >
                            Abhishek
                          </button>
                        </li>

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "pooja")
                            }
                          >
                            Pooja
                          </button>
                        </li>

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "bhandara")
                            }
                          >
                            Bhandara / Yatra
                          </button>
                        </li>

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "bhojan")
                            }
                          >
                            Bhojan Prasadi
                          </button>
                        </li>

                        <li>
                          <button
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#detailModal"
                            onClick={() =>
                              openPopup(t, "trustees")
                            }
                          >
                            Trustees
                          </button>
                        </li>

                        {/* NEW OPTION */}

                        <li>
                          <button
                            className="dropdown-item text-primary"
                            onClick={() =>
                              navigate(`/gallery/${t._id}`)
                            }
                          >
                            📷 Photos & Videos
                          </button>
                        </li>

                      </ul>

                    </div>

                  </div>

                </div>

              </div>
            );
          })

        )}

      </div>

      {/* POPUP MESSAGE BOX */}

      <div className="modal fade" id="detailModal">

        <div className="modal-dialog modal-dialog-centered">

          <div
            className="modal-content"
            style={{ borderRadius: "15px" }}
          >

            <div
              className="modal-header"
              style={{
                background: "#ff9800",
                color: "white"
              }}
            >

              <h5 className="modal-title">
                {popupTitle}
              </h5>

              <button
                className="btn-close"
                data-bs-dismiss="modal"
              />

            </div>

            <div
              className="modal-body"
              style={{
                height: "250px",
                overflowY: "auto",
                background: "#fffaf0",
                fontSize: "15px",
                lineHeight: "1.7"
              }}
            >

              <p style={{ whiteSpace: "pre-wrap" }}>
                {popupContent ||
                  "Information will be updated soon."}
              </p>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

}

export default TempleList;